import { showToast } from '../../../helpers/showToast';
import { getSessionToast } from '../../../helpers/sessionToastHelpers';
import { useDidMount } from 'hooks/useDidMount';
import { AnyObject } from 'models/basic-objects';

export const SessionToastView = (props: AnyObject & { children: JSX.Element }): JSX.Element => {
  useDidMount(() => {
    const sessionToast = getSessionToast();
    if (sessionToast) {
      showToast({ severity: sessionToast.severity, detail: sessionToast.detail, summary: sessionToast.summary });
    }
  });

  return props.children;
};
